import src from "IMAGE";
export default { src, width: 222, height: 199, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
